export class CurrenciesSettings{
    /**
     * 1: EUR
     * 2: GBP
     * 3: USD
     */
    public static currenciesMap:any = {
        'ES': 1,
        'GB': 2,
        'US': 3,
        'IE': 1,
        'AL': 1,
        'AD': 1,	
        'AT': 1,	
        'BY': 1,	
        'BE': 1,	
        'BA': 1,	
        'BG': 1,	
        'HR': 1,	
        'CY': 1,	
        'CZ': 1,	
        'DK': 1,	
        'EE': 1,	
        'FO': 1,	
        'FI': 1,	
        'FR': 1,	
        'DE': 1,	
        'GI': 1,	
        'GR': 1,	
        'HU': 1,	
        'IS': 1,	
        'IM': 1,	
        'IT': 1,	
        'RS': 1,	
        'LV': 1,	
        'LI': 1,	
        'LT': 1,	
        'LU': 1,	
        'MK': 1,	
        'MT': 1,	
        'MD': 1,	
        'MC': 1,	
        'ME': 1,	
        'NL': 1,	
        'NO': 1,	
        'PL': 1,	
        'PT': 1,	
        'RO': 1,	
        'RU': 1,	
        'SM': 1,	
        'SK': 1,	
        'SI': 1,	
        'SE': 1,	
        'CH': 1,	
        'UA': 1,	
        'VA': 1	
    }
}